import api from '../index';

export default {
  get(q = '', month = null, status = '') {
    let url = '/blog/banners';
    const filters = [];

    q.trim() !== '' && filters.push(`q=${q}`);
    month && filters.push(`month=${month}`);
    status.trim() !== '' && filters.push(`status=${status}`);

    url = `${url}?${filters.join('&')}`;

    return api.get(url);
  },
  getById(id) {
    return api.get(`/blog/banners/${id}`);
  },
  create(payload) {
    return api.post(`/blog/banners`, { blog_banners: payload });
  },
  update(payload) {
    return api.put(`/blog/banners`, { blog_banners: [payload] });
  },
  updateMultiple(payload) {
    return api.put(`/blog/banners`, { blog_banners: payload });
  },
};
